import {
  IInpatientRuleset,
  IInpatientRulesetResponse,
  IAllInpatientRulesetsResponse,
} from "types/InpatientRuleset";

import { api } from ".";

const inpatientRulesetQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getInpatientRulesets: builder.query<
      IAllInpatientRulesetsResponse,
      null | void
    >({
      query: () => "inpatient-rulesets",
      providesTags: ["InpatientRulesets"],
    }),
    getInpatientRuleset: builder.query<IInpatientRulesetResponse, string>({
      query: (id) => `inpatient-rulesets/${id}`,
      providesTags: (_result, _error, id) => [
        { type: "InpatientRulesets", id },
      ],
    }),
    getInpatientRulesetsByContract: builder.query<
      IAllInpatientRulesetsResponse,
      { providerId: string; payerId: number }
    >({
      query: ({ providerId, payerId }) =>
        `inpatient-rulesets/by-contract/${providerId}/${payerId}`,
      providesTags: ["InpatientRulesets"],
    }),
    createInpatientRuleset: builder.mutation<
      IInpatientRulesetResponse,
      Omit<
        IInpatientRuleset,
        "id" | "createdAt" | "updatedAt" | "provider" | "payer"
      >
    >({
      query: (body) => ({
        url: "inpatient-rulesets",
        method: "POST",
        body,
      }),
      invalidatesTags: ["InpatientRulesets"],
    }),
    updateInpatientRuleset: builder.mutation<
      IInpatientRulesetResponse,
      {
        id: string;
        body: Partial<
          Omit<
            IInpatientRuleset,
            "id" | "createdAt" | "updatedAt" | "provider" | "payer"
          >
        >;
      }
    >({
      query: ({ id, body }) => ({
        url: `inpatient-rulesets/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["InpatientRulesets"],
    }),
    deleteInpatientRuleset: builder.mutation<any, string>({
      query: (id) => ({
        url: `inpatient-rulesets/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["InpatientRulesets"],
    }),
  }),
});

export const {
  useGetInpatientRulesetsQuery,
  useGetInpatientRulesetQuery,
  useGetInpatientRulesetsByContractQuery,
  useCreateInpatientRulesetMutation,
  useUpdateInpatientRulesetMutation,
  useDeleteInpatientRulesetMutation,
} = inpatientRulesetQueries;
